import React from 'react';
import type { Ref } from 'react';
import { AnchorId } from '../../core/Enums';
import type { MaintenanceRequest } from '../../core/Types';
import { useTourAnchor } from '../../hooks/useTourAnchor';
import { ChevronDownIcon, MenuButtonIcon } from '../../icons/TourIcons';
import RequestRow from './RequestRow';
import panelStyles from '../../stylesheets/maintenance/requestsPanel.module.scss';

interface RequestsPanelProps {
  requests: MaintenanceRequest[];
  unassignedCount: number;
  previewButtonLabel?: string;
  previewButtonRef?: Ref<HTMLButtonElement>;
  onPreviewClick?: () => void;
  onRequestSelect: (requestId: string) => void;
}

const RequestsPanel = ({
  requests,
  unassignedCount,
  previewButtonLabel,
  previewButtonRef,
  onPreviewClick,
  onRequestSelect,
}: RequestsPanelProps) => {
  const requestListRef = useTourAnchor(AnchorId.MAINTENANCE_REQUEST_LIST);

  return (
    <section className={panelStyles.requestsPanel}>
      <div className={panelStyles.requestsHeader}>
        <h2 className={panelStyles.requestsTitle}>Maintenance</h2>
        <button
          className={panelStyles.headerMenuButton}
          type="button"
          aria-label="More options"
        >
          <MenuButtonIcon />
        </button>
        <p className={panelStyles.requestsSubtitle}>
          {unassignedCount} request{unassignedCount === 1 ? '' : 's'} needs
          assignment
        </p>
        <div className={panelStyles.headerActions}>
          <button className={panelStyles.secondaryButton} type="button">
            Maintenance Schedules
          </button>
          <button className={panelStyles.primaryButton} type="button">
            New Request
          </button>
        </div>
      </div>
      <div className={panelStyles.listHeader}>
        <span>Request</span>
        <span>Status</span>
        <span>Vendor</span>
        <span>Requested</span>
      </div>
      <div className={panelStyles.requestList} ref={requestListRef}>
        {requests.map((request) => (
          <RequestRow
            key={request.id}
            request={request}
            isSpotlightTarget={requests[0]?.id === request.id}
            onSelect={onRequestSelect}
          />
        ))}
      </div>
      {previewButtonLabel && onPreviewClick && (
        <button
          type="button"
          className={panelStyles.previewTenantButton}
          onClick={onPreviewClick}
          ref={previewButtonRef}
        >
          {previewButtonLabel}
          <span className={panelStyles.previewTenantButtonIcon}>
            <ChevronDownIcon />
          </span>
        </button>
      )}
    </section>
  );
};

export default RequestsPanel;
